import React, { useState } from 'react'
import { SettingsMenuButton } from 'src/editor/shared/components/settings-menu-button'
import { BackButton } from 'src/editor/shared/components/back-button'
import { twMerge } from 'tailwind-merge'

interface SettingsNestedMenuProps {
  isFirst?: boolean
  menuButtonLabel: string
  menuTitle: string
  children: React.ReactNode
}

export const SettingsNestedMenu = ({
  isFirst,
  menuButtonLabel,
  menuTitle,
  children,
}: SettingsNestedMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div
      className={twMerge(
        isFirst && 'mt-4 border-0.5 border-border200 border-t pt-3',
      )}
    >
      <SettingsMenuButton onClick={() => setIsOpen(true)}>
        {menuButtonLabel}
      </SettingsMenuButton>
      {isOpen && (
        <div className="absolute inset-0 bg-bgPrimaryBase p-[var(--sidebar-padding)]">
          <BackButton className="mb-6!" onClick={() => setIsOpen(false)} />
          <div className="mb-6 text-heading-4">{menuTitle}</div>
          {children}
        </div>
      )}
    </div>
  )
}
